import { vehicleSize } from "pages/routeplans/const";
import React, { useEffect } from "react";
import { SelectInput } from "react-admin";
import { useField } from "react-final-form";

interface IVehicleSizeInput {
  record: any;
}

const VehicleSizeInput = ({ record }: IVehicleSizeInput) => {
  const {
    input: { onChange },
  } = useField("route.assignedSubcontractor.vehicleSize");

  useEffect(() => {
    if (record) {
      if (record.vehicleSize) {
        onChange(record.vehicleSize);
      }
    }
  }, [record]);

  return (
    <SelectInput
      label="Vehicle Size *"
      source="route.assignedSubcontractor.vehicleSize"
      choices={vehicleSize}
    />
  );
};

export default VehicleSizeInput;
